import { StatusBar, Style } from "@capacitor/status-bar";
import { Capacitor } from "@capacitor/core";
import { useAtom } from "jotai";
import { highContrastAtom } from "../jotai/atoms";

export default function NativeStatusBar() {
  const [highContrast] = useAtom(highContrastAtom);

  if (Capacitor.isNativePlatform()) {
    StatusBar.setOverlaysWebView({ overlay: false });
    StatusBar.setStyle({
      style: Style.Dark,
    });
    StatusBar.setBackgroundColor({ color: highContrast ? "#032238" : "#1c9ad4" });
  }

  return null;
}
